export const ENUM_COUNTDOWN_BAR_IMAGE_TYPE = {
  HALF: 'HALF',
  FULL: 'FULL',
};

// Vị trí hiển thị, khớp "Tùy chọn cài đặt" trên CMS marketing
export const ENUM_COUNTDOWN_BAR_TYPE = {
  WEBSITE: 'WEBSITE',
  PRODUCT_CATALOG: 'PRODUCT_CATALOG',
};
